class AddressSuggestions {
    input;
    container;
    apiKey;
    requestTimeout;
    handleDocumentClick;
    suggestions;

    constructor(input, container, apiKey) {
        this.input = input;
        this.container = container;
        this.apiKey = apiKey || backendData?.dadataApiKey || '';
        this.requestTimeout = null;

        if (this.input && this.container && this.apiKey) {
            this.init();
        }
    }

    init() {
        this.input.addEventListener("input", this._handleAddressInput);
        this.input.addEventListener("focus", this._handleAddressFocus);
        this.input.addEventListener("blur", this._handleAddressBlur);

        // Закрываем попап при клике вне его
        this.handleDocumentClick = (e) => {
            if (
                !this.input.contains(e.target) &&
                !this.container.contains(e.target)
            ) {
                this._hideSuggestions();
            }
        };
        document.addEventListener("click", this.handleDocumentClick);
    }

    destroy() {
        if (this.handleDocumentClick) {
            document.removeEventListener("click", this.handleDocumentClick);
        }
        if (this.requestTimeout) {
            clearTimeout(this.requestTimeout);
        }
    }

    _handleAddressInput = (e) => {
        const query = e.target.value.trim();

        // Очищаем предыдущий таймаут
        if (this.requestTimeout) {
            clearTimeout(this.requestTimeout);
        }

        // Если меньше 3 символов, скрываем попап
        if (query.length < 3) {
            this._hideSuggestions();
            return;
        }

        // Дебаунс запроса - продолжаем искать при любом вводе
        this.requestTimeout = setTimeout(() => {
            this._fetchAddressSuggestions(query);
        }, 300);
    };

    _handleAddressFocus = (e) => {
        const query = e.target.value.trim();
        if (query.length >= 3) {
            this._fetchAddressSuggestions(query);
        }
    };

    _handleAddressBlur = (e) => {
        // Небольшая задержка, чтобы клик по элементу успел сработать
        setTimeout(() => {
            const activeElement = document.activeElement;
            if (
                activeElement !== this.input &&
                !this.container.contains(activeElement)
            ) {
                this._hideSuggestions();
            }
        }, 200);
    };

    _fetchAddressSuggestions = async (query) => {
        if (!this.apiKey) {
            return;
        }

        try {
            this._showLoading();

            const response = await fetch("https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Token ${this.apiKey}`,
                },
                body: JSON.stringify({
                    query: query,
                    count: 5,
                }),
            });

            if (!response.ok) {
                throw new Error("Ошибка запроса к DaData");
            }

            const data = await response.json();
            this.suggestions = data.suggestions;

            this._showSuggestions(data.suggestions || []);
        } catch (error) {
            console.error("Ошибка при получении подсказок адресов:", error);
            this._hideSuggestions();
        }
    };

    _fetchAddressClear = async (query) => {
        console.log('_fetchAddressClear');
        if (!this.apiKey) {
            return;
        }

        try {
            const response = await fetch("https://cleaner.dadata.ru/api/v1/clean/address", {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Token ${this.apiKey}`,
                },
                body: JSON.stringify([query]),
            });

            if (!response.ok) {
                throw new Error("Ошибка запроса к DaData");
            }

            const data = await response.json();
            console.log(data)

        } catch (error) {
            console.error("Ошибка при получении подсказок адресов:", error);

        }
    };

    _showLoading() {
        this.container.innerHTML = '<div class="address-suggestions__item address-suggestions__item--loading">Загрузка...</div>';
        this.container.classList.add("is-visible");
    }

    _showSuggestions(suggestions) {
        if (suggestions.length === 0) {
            this._hideSuggestions();
            return;
        }

        this.container.innerHTML = suggestions
            .map(
                (suggestion, index) => `
      <div class="address-suggestions__item" data-index="${index}" data-value="${this._escapeHtml(suggestion.value)}">
        ${this._escapeHtml(suggestion.value)}
      </div>
    `
            )
            .join("");

        // Добавляем обработчики кликов
        this.container.querySelectorAll(".address-suggestions__item").forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                const geoData = this.suggestions[item.dataset.index];

                //console.log(geoData);
                //this._fetchAddressClear(geoData.value);

                this.input.dataset.city = geoData.data.city_with_type;
                this.input.dataset.address = geoData.data.street_with_type != null ? geoData.data.street_with_type : '';
                if (geoData.data.house != null) {
                    this.input.dataset.address += ', ' + geoData.data.house_type + ' ' + geoData.data.house;
                }

                //console.log(this.input.dataset.address);

                this.input.dataset.postcode = geoData.data.postal_code ? geoData.data.postal_code : '';
                this.input.dataset.state = geoData.data.region_with_type ? geoData.data.region_with_type : '';;
                this.input.dataset.cityFiasId = geoData.data.city_fias_id ? geoData.data.city_fias_id : '';;

                const value = item.dataset.value;
                this.input.value = value;
                this.input.dispatchEvent(new Event('change', { bubbles: true }));
                // Закрываем попап после выбора
                this._hideSuggestions();

                // Устанавливаем курсор в конец и возвращаем фокус
                const input = this.input;
                setTimeout(() => {
                    input.setSelectionRange(input.value.length, input.value.length);
                    input.focus();
                }, 10);
            });
        });

        this.container.classList.add("is-visible");
    }

    _hideSuggestions() {
        this.container.classList.remove("is-visible");
        this.container.innerHTML = "";
    }

    _escapeHtml(text) {
        const div = document.createElement("div");
        div.textContent = text;
        return div.innerHTML;
    }
}

export default AddressSuggestions;

